import { APICall } from "@/config/NetworkUtility";
import { logApiError } from "@/services/apiErrorLogger";
import { createAsyncThunk } from "@reduxjs/toolkit";

export const getNavigationVisibility = createAsyncThunk(
  "navigationVisibility/getNavigationVisibility",
  async (payload, { rejectWithValue }) => {
    try {
      const queryParams = new URLSearchParams({
        ...payload,
      }).toString();

      const url = `v2/NavigationSetup/GetNavigatioVisibilityList?${queryParams}`;

      const result = await APICall("get", payload, url);

      if (result?.statuscode === 200 || result?.statuscode === 201) {
        return result?.data || [];
      }

      return rejectWithValue(result);
    } catch (error) {
      logApiError(error, {
        source: "navigationVisibility",
        endpoint: "getNavigationVisibility",
        payload,
      });

      return rejectWithValue(error);
    }
  },
);

export const saveNavigationVisibility = createAsyncThunk(
  "navigationVisibility/saveNavigationVisibility",
  async (treeData, { rejectWithValue }) => {
    try {
      const formData = new FormData();

      formData.append("JsonStringValue", JSON.stringify(treeData));

      const result = await APICall(
        "post",
        formData,
        "v1/NavigationSetup/NavigationVisibilityProcess",
      );

      if (result?.statuscode === 200 || result?.statuscode === 201) {
        return result;
      }

      return rejectWithValue(result);
    } catch (error) {
      logApiError(error, {
        source: "navigationVisibility",
        endpoint: "saveNavigationVisibility",
      });

      return rejectWithValue(error);
    }
  },
);
